import optenSearchController from './opten-search-controller';

export default function (app) {
	app.component('optenSearch', {
		transclude: true,
		bindings: {
			companyModel: '=',
			forCompany: '<', // company/partner
			taggingFunction: '&',
			onSelectFunction: '&?',
			searchFunction: '&?',
			form: '=',
			optenOnly: '<',
			invoiceProperty: '@?',
			addEmptyLastElement: '<'
		},
		templateUrl: 'common/opten-search',
		controller: ['SearchService', 'PartnerService', 'QueryParamService', '$q', '$timeout', '$filter', 'EndPointProtection', optenSearchController]
	});
}
